import { CurrencyPipe } from '@angular/common';
import { inject, Pipe, PipeTransform } from '@angular/core';

import { InternationalizationService } from '@services/utils/internationalization/internationalization.service';

@Pipe({ name: 'money' })
export class MoneyPipe implements PipeTransform {
    private readonly COUNTRY_LOCALE_MAP: Record<string, string> = {
        ES: 'es-ES',
        MX: 'es-MX',
        CO: 'es-CO',
        AR: 'es-AR',
        CL: 'es-CL',
        UY: 'es-UY',
        BR: 'pt-BR',
        BO: 'es-BO',
        PA: 'es-PA',
        PE: 'es-PE',
        CR: 'es-CR',
        PY: 'es-PY',
        SV: 'es-SV',
    };
    private readonly internationalizationService = inject(InternationalizationService);
    private readonly currencyPipe = inject(CurrencyPipe);

    transform(
        value: any,
        code = this.internationalizationService.getCurrency(),
        display = 'symbol-narrow',
        digits = this.internationalizationService.getDigits(),
        locale = this.COUNTRY_LOCALE_MAP[this.internationalizationService.getCountryCode()]): string | null {
        return this.currencyPipe.transform(value, code, display, digits, locale);
    }

}
